import { GTM } from "../app/shared/constants/variables.constants";

export const commonCbEnv = {
  clientCode: 'CB',
  productCode: '',
  local: false,
  production: true,
  valentin: false,
  bogdan: true,
  moneydays: false,
  dan: false,
  hubix: false,
  client: {
    sb: false,
    cb: true,
    ib: false,
  },
  google_tagmanager_id: GTM.CARUTA_CU_BANI,
  tosUrl: {
    policy: 'https://carutacubani.ro/politica-de-confidentialitate/',
    protectiaDatelor: 'https://carutacubani.ro/politica-de-protectie-a-datelor-cu-caracter-personal/',
    cookies: 'https://carutacubani.ro/privacy-policy/',
  },
  favicon: 'assets/images/favicon-cb.ico',
  page: '',
  pageCode: '',
  meta: {
    siteTitle: 'Caruta Cu Bani',
    siteDescription: '',
    ogSiteName: 'Caruta Cu Bani',
    ogUrl: '',
    ogImage: '',
    ogImageAlt: ''
  },
  landingPage: {
    BURSA_1: 'https://carutacubani.ro/cursuri/curs-investitii-eficiente-pe-bursa/',
    BURSA_2: 'https://carutacubani.ro/cursuri/curs-investitii-eficiente-pe-bursa-nivelul-2/',
    cursIINivel1: 'https://carutacubani.ro/cursuri/curs-investitii-eficiente-pe-bursa/',
    cursIINivel2: 'https://carutacubani.ro/cursuri/curs-investitii-eficiente-pe-bursa-nivelul-2/',
    cursIINivel3: 'https://carutacubani.ro/cursuri/curs-investitii-eficiente-pe-bursa-pentru-dividende/',
    imobiliare: 'https://carutacubani.ro/cursuri/curs-imobiliare/',
    imobiliareNivel2: 'https://carutacubani.ro/cursuri/curs-investitii-imobiliare-nivelul-2/',
    imobiliareApartamente: 'https://carutacubani.ro/cursuri/curs-investitii-imobiliare-apartamente/',
    incomeAccelerator: 'https://carutacubani.ro/cursuri/income-accelerator/',
    cpip: '',
    cip: '',
    sbP12: '',
    moneySmart: 'https://carutacubani.ro/cursuri/moneysmart/',
    moneydays: '',
    conferintaSb: '',
    conferintaSb2024: '',
    deNeinvins: '',
    primulPortofoliu: '',
    rstCursBursa: '',
  },
  product: {
    cursIINivel2: {
      silver: 'https://carutacubani.ro/cart/?add-to-cart=7927',
      gold: 'https://carutacubani.ro/cart/?add-to-cart=7928',
      vip: 'https://carutacubani.ro/cart/?add-to-cart=7929',
    },
    cursIINivel1: {
      silver: 'https://carutacubani.ro/cart/?add-to-cart=4401',
      gold: 'https://carutacubani.ro/cart/?add-to-cart=5095',
      vip: 'https://carutacubani.ro/cart/?add-to-cart=5096',
    },
    cursIINivel3: {
      silver: 'https://carutacubani.ro/cart/?add-to-cart=11013',
      gold: 'https://carutacubani.ro/cart/?add-to-cart=11014',
      vip: 'https://carutacubani.ro/cart/?add-to-cart=11015',
    },
    imobiliare: {
      silver: 'https://carutacubani.ro/cart/?add-to-cart=4115',
      gold: 'https://carutacubani.ro/cart/?add-to-cart=7234',
      vip: 'https://carutacubani.ro/cart/?add-to-cart=7235',
    },
    imobiliareNivel2: {
      silver: 'https://carutacubani.ro/cart/?add-to-cart=9405',
      gold: 'https://carutacubani.ro/cart/?add-to-cart=9406',
      vip: 'https://carutacubani.ro/cart/?add-to-cart=9407',
    },
    imobiliareApartamente: {
      silver: 'https://carutacubani.ro/cart/?add-to-cart=17816',
      gold: 'https://carutacubani.ro/cart/?add-to-cart=17817',
    },
    moneySmart: {
      silver: 'https://carutacubani.ro/cart/?add-to-cart=5852',
      gold: 'https://carutacubani.ro/cart/?add-to-cart=5853',
      vip: 'https://carutacubani.ro/cart/?add-to-cart=5854',
    },
    cpip: {
      silver: '',
      gold: '',
      vip: '',
    },
    cip: {
      silver: '',
      gold: '',
      vip: '',
    },
    conferintaSb: {
      silver: '',
      gold: '',
      vip: '',
    },
    conferintaSb2025: {
      silver: '',
      gold: '',
      vip: '',
    },
    incomeAccelerator: {
      silver: 'https://carutacubani.ro/cart/?add-to-cart=6394',
      gold: 'https://carutacubani.ro/cart/?add-to-cart=6395',
      vip: 'https://carutacubani.ro/cart/?add-to-cart=6396',
    },
    moneydays: {
      silver: '',
      gold: '',
      vip: '',
    },
    primulPortofoliu: {
      silver: ''
    },
    deNeinvins: {
      silver: '',
    },
    sbPachetIncepatori: {
      silver: '',
    },
    sbPachetAvansati: {
      silver: '',
    },
    sbPachetToateCursurile: {
      silver: '',
    },
    sbPachetInvestitii: {
      silver: '',
    },
    sbPachetEndlessPerfectSummer: {
      silver: '',
    },
    sbPachetMinicursuri: {
      silver: '',
    },
    sbP10: {
      silver: '',
    },
    sbP12: {
      silver: '',
    },
    sbPachetMentoring: {
      silver: '',
    },
    cbPachetToateCursurile: {
      silver: 'https://carutacubani.ro/cart/?add-to-cart=6591',
    },
    cbPachetInvestitii: {
      silver: 'https://carutacubani.ro/cart/?add-to-cart=13262',
    },
    cbPachetInitiere: {
      silver: 'https://carutacubani.ro/cart/?add-to-cart=13265',
    },
    cbPachetMentoring: {
      silver: 'https://carutacubani.ro/cart/?add-to-cart=13267',
    },
    cbPachetBursa: {
      silver: 'https://carutacubani.ro/cart/?add-to-cart=15717',
    },
    cbPachetImobiliare: {
      silver: 'https://carutacubani.ro/cart/?add-to-cart=15718',
    },
    rstCursBursa: {
      silver: '',
    },
  }
};
